export enum AppendToBodyPositionTypeEnum {
    BOTTOM_LEFT = 'BottomLeft',
    TOP_RIGHT = 'TopRight',
}
